<template>
    <iframe
        ref="iframe"
        title="Preview"
        :srcdoc="formattedSrcdoc"
        class="preview-iframe"
    />
</template>

<script setup lang="ts">
    import { computed, ref } from 'vue';

    import type { LayoutSize } from '@keyvue/one-api-client';

    interface Props {
        srcdoc: string,
        size?: LayoutSize,
    }

    const props = defineProps<Props>();

    const iframe = ref<HTMLIFrameElement>();

    const calculateZoom = () => {
        if (props.size === undefined) {
            return 1.0;
        }

        const pageWidth = props.size.width;
        const iframeWidth = (iframe.value?.clientWidth ?? pageWidth);
        const iframePadding = 16 + 16 + 32;

        return Math.min(1, (iframeWidth - iframePadding) / pageWidth);
    };

    const formattedSrcdoc = computed(() => {
        const zoom = calculateZoom();

        let { srcdoc } = props;
        const srcdocStyling = `
            <style>
                html {
                    -moz-transform: scale(${zoom});
                    -moz-transform-origin: 0 0;
                    -o-transform: scale(${zoom});
                    -o-transform-origin: 0 0;
                    -webkit-transform: scale(${zoom});
                    -webkit-transform-origin: 0 0;
                }
            </style>
        `;

        if (srcdoc?.indexOf('<head>') !== -1) {
            srcdoc = srcdoc?.replace('<head>', `<head>${srcdocStyling}`);
        } else if (srcdoc?.indexOf('<html>') !== -1) {
            srcdoc = srcdoc?.replace('<html>', `<html><head>${srcdocStyling}</head>`);
        } else {
            srcdoc += srcdocStyling;
        }

        return srcdoc;
    });
</script>

<style scoped lang="scss">
.preview-iframe {
    width: 100%;
    height: 896px;
    border: none;
}
</style>
